/** @format */

import React from "react";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { CashierFormProps } from "../../../Types/Forms.type";

export default function CashierInfo({
  formData,
  updateFormData,
}: CashierFormProps) {
  return (
    <Form className="needs-validation custom-input">
      <Row className="g-3">
        <Col xxl={6} sm={6}>
          <Label>
            {"Full Name"}
            <span className="txt-danger">*</span>
          </Label>
          <Input
            placeholder="Enter full name"
            type="text"
            name="full_name"
            value={formData.full_name}
            onChange={updateFormData}
          />
        </Col>
        <Col xxl={6} sm={6}>
          <Label>
            {"Email"}
            <span className="txt-danger">*</span>
          </Label>
          <Input
            type="email"
            placeholder="Enter email"
            name="email"
            value={formData.email}
            onChange={updateFormData}
          />
        </Col>
        <Col xxl={6} sm={6}>
          <Label>{"Contact Number"}</Label>
          <Input
            name="phone_number"
            placeholder="Enter phone number"
            type="text"
            value={formData.phone_number}
            onChange={updateFormData}
          />
        </Col>
        <Col xxl={6} sm={6}>
          <Label>{"Address"}</Label>
          <Input
            placeholder="Enter your address"
            name="address"
            type="text"
            value={formData.address}
            onChange={updateFormData}
          />
        </Col>
        <Col xxl={6} sm={6}>
          <Label>{"City"}</Label>
          <Input
            placeholder="Enter your city"
            name="city"
            type="text"
            value={formData.city}
            onChange={updateFormData}
          />
        </Col>
        <Col xxl={6} sm={6}>
          <Label>{"Password"}</Label>
          <span className="txt-danger">*</span>
          <Input
            type="password"
            placeholder="Enter password"
            name="password"
            value={formData.password}
            onChange={updateFormData}
          />
        </Col>
        <Col xxl={6} sm={6}>
          <Label>{"POS Code"}</Label>
          <span className="txt-danger">*</span>
          <Input
            placeholder="Enter 4-digit POS code"
            type="text"
            name="pos_code"
            maxLength={4} // Restricts input length
            value={formData.pos_code}
            onChange={updateFormData}
          />
        </Col>
        <Col xxl={6} sm={6}>
          <FormGroup tag="fieldset">
            <Label>Role</Label>
            <span className="txt-danger">*</span>
            <FormGroup check>
              <Label check>
                <Input
                  type="radio"
                  name="role"
                  value="wc_product_vendors_admin_vendor"
                  checked={formData.role === "wc_product_vendors_admin_vendor"}
                  onChange={updateFormData}
                />
                Vendor Admin
              </Label>
            </FormGroup>
            <FormGroup check>
              <Label check>
                <Input
                  type="radio"
                  name="role"
                  value="wc_product_vendors_manager_vendor"
                  checked={
                    formData.role === "wc_product_vendors_manager_vendor"
                  }
                  onChange={updateFormData}
                />
                Vendor Manager
              </Label>
            </FormGroup>
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
}
